import { SnSize } from '@lib/common/types';
import { SnPointLike } from '@lib/geo/helpers';
import { SnBadgeConfig } from '@lib/ui/badge';

import { IBaseEsriMarkerOptions } from './base-marker-options';

export interface IEsriMapFontIcon {
  fontIcon: string;
  fontSet: string;
  size?: SnSize;
}

export interface IEsriMapFontIconUnicode {
  fontIconUnicode: string;
  fontSet: string;
}

export interface IEsriMapNameIcon {
  name: string;
}

export interface IEsriMapIconMarkerOptions extends IBaseEsriMarkerOptions {
  scale?: number;
  color?: string;
  anchor?: SnPointLike;
  badge?: SnBadgeConfig;
}

export type EsriMapIconMarkerIcon = string | IEsriMapFontIcon | IEsriMapFontIconUnicode;

export type EsriMapIconMarkerOptions =
  | (IEsriMapNameIcon & IEsriMapIconMarkerOptions)
  | (IEsriMapFontIcon & IEsriMapIconMarkerOptions)
  | (IEsriMapFontIconUnicode & IEsriMapIconMarkerOptions);
